import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import { ChariotConfig, ChariotAlarm, configFromJson, jsonFromConfig } from "models/ChariotConfig"
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import Loader from '../../Utils/Loader/NewLoader2025'
import { inputUnits } from '../../Utils/CurrentInputUnits'


interface Props {
    product: string
    serial: number | undefined
}

interface ChannelTypes {
    channelA: string
    channelB: string
    channelC: string
    channelD: string

}

const ConfigOverview: React.FC<Props> = ({ product, serial }) => {

    //hooks
    const intl: IntlShape = useIntl()


    //state

    const [deviceConfig, setDeviceConfig] = useState<ChariotConfig | null>()
    const [channelTypes, setChannelTypes] = useState<ChannelTypes | null>()
    const [loading , setLoading] = useState<boolean>(true)

    /// useEffect for inital load
    useEffect(() => {
        reloadData()
    }, [product, serial])


    
    const reloadData = ():void => {
        CallGetAPI(CreateUrl('/api/aquaguard/CurrentLCLoggerConfiguration?serial=' + serial), {})
            .then(data => {
                if (data.status === undefined) {
                    const config = configFromJson(product,
                        data, false
                    );
                    const channelTypesTemp = {
                        channelA: flowPulseType(config.FlowAPulseType),
                        channelB: flowPulseType(config.FlowBPulseType),
                        channelC: flowPulseType(config.FlowAPulseType),
                        channelD: flowPulseType(config.FlowAPulseType)
                    }
                    setDeviceConfig(config)
                    setChannelTypes(channelTypesTemp)
                    setLoading(false)
                }
            })
    }

    const flowPulseType = (numberType: number):string => {
        switch (numberType) {
            case 1:
                return intl.formatMessage({ id: 'Forward' })
            case 2: 
                return intl.formatMessage({ id: 'Fwd/Rev' })
            case 3:
                return intl.formatMessage({ id: 'Fwd/Dir' })
            case 17:
                return intl.formatMessage({ id: 'Forward (PIT)' })
            case 18:
                return intl.formatMessage({ id: 'Fwd/Rev (PIT)' })
            case 20:
                return intl.formatMessage({ id: 'Digital' })
            default:
                return 'unknown'
        }
    }




    const styling = {
        padding: '4px 10px',
    }

    return (
        <div style={{position: "relative", minHeight: 200} }>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: 0,
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000

                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading && 
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <h5 style={{ textAlign: "center" }}><b><FormattedMessage id="Configuration Overview" /></b></h5>
                    <div style={{ display: "flex", color: "white" }}>
                        <p style={{ ...styling, background: deviceConfig?.FlowA ? '#00BF00' : 'red' }}>Channel A: {deviceConfig?.FlowA ? <i className="dx-icon-check"></i> : <i className="dx-icon-remove"></i>}</p>
                        <p style={{ ...styling , color: "black"} }>{channelTypes?.channelA}</p>
                    </div>
                    <div style={{ display: "flex", color: "white" }}>
                        <p style={{ background: deviceConfig?.FlowB ? '#00BF00' : 'red', ...styling }}>Channel B: {deviceConfig?.FlowB ? <i className="dx-icon-check"></i> : <i className="dx-icon-remove"></i>}</p>
                        <p style={{ ...styling, color: "black" }}>{channelTypes?.channelB}</p>
                    </div>


                    <div style={{ display: "flex", color: "white" }}>
                        <div>
                            <p style={{ ...styling, background: deviceConfig?.AnalogueC ? '#00BF00' : 'red', marginTop: deviceConfig?.AnalogueC ? "16px" : 0 }}>Channel C: {deviceConfig?.AnalogueC ? <i className="dx-icon-check"></i> : <i className="dx-icon-remove"></i>}</p>
                        </div>
                        {deviceConfig?.AnalogueC && <div>
                            <p style={{ ...styling, color: "black", margin: 0 }}>Min Value: {deviceConfig?.AnalogueCMapMin.toFixed(2)} {deviceConfig?.AnalogueCUnits ? inputUnits[deviceConfig.AnalogueCUnits].name : ""}</p>
                            <p style={{ ...styling, color: "black" }}>Max Value: {deviceConfig?.AnalogueCMapMax.toFixed(2)} {deviceConfig?.AnalogueCUnits ? inputUnits[deviceConfig.AnalogueCUnits].name : ""}</p>
                        </div>}
                    </div>
                    <div style={{ display: "flex", color: "white" }}>
                        <div>
                            <p style={{ ...styling, background: deviceConfig?.AnalogueD ? '#00BF00' : 'red', marginTop: deviceConfig?.AnalogueD ? "16px" : 0 }}>Channel D: {deviceConfig?.AnalogueD ? <i className="dx-icon-check"></i> : <i className="dx-icon-remove"></i>}</p>
                        </div>
                        {deviceConfig?.AnalogueD && <div>
                            <p style={{ ...styling, color: "black", margin: 0 }}>Min Value: {deviceConfig?.AnalogueDMapMin.toFixed(2)} {deviceConfig?.AnalogueCUnits ? inputUnits[deviceConfig.AnalogueDUnits].name : ""}</p>
                            <p style={{ ...styling, color: "black" }}>Max Value: {deviceConfig?.AnalogueDMapMax.toFixed(2)} {deviceConfig?.AnalogueDUnits ? inputUnits[deviceConfig.AnalogueDUnits].name : ""}</p>
                        </div>}
                    </div>
                
                </div>
            }
        </div>
    )
}
export default ConfigOverview


                  